export const DS_CONNECT = 'DS_CONNECT';
export const DS_CONNECT_ERROR = 'DS_CONNECT_ERROR';
export const DS_CONNECT_SUCCESS = 'DS_CONNECT_SUCCESS';
export const DS_DISCONNECT = 'DS_DISCONNECT';
